import { useQuery } from '@apollo/client';
import { generatedTypesNew } from '@css-xp/graphtypes';
import React from 'react';
import { SIDEBAR } from '../../components/entitlement-page';
import './customer-contact-tab.scss';
import CustomerContacts from './customer-contacts';
import { fetchCustomerContactForEntitlement } from './queries/fetch-customer-contacts';

interface CustomerContactsTabProps {
  entitlementId: generatedTypesNew.EntitlementDetails['id'];
  transactionAccountId: generatedTypesNew.EntitlementDetails['transactionAccountId'];
}

export const CustomerContactsTab = ({ entitlementId, transactionAccountId }: CustomerContactsTabProps) => {
  const { data, loading, refetch, error } = useQuery<
    generatedTypesNew.FetchCustomerContactForEntitlementQuery,
    generatedTypesNew.FetchCustomerContactForEntitlementQueryVariables
  >(fetchCustomerContactForEntitlement, {
    variables: { id: entitlementId },
    displayName: `fetchCustomerContactForEntitlement`,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-first',
  });

  const endCustomerContacts = data?.entitlementDetails?.endCustomerContacts as generatedTypesNew.EndCustomerContact[];
  const totalCount = endCustomerContacts?.length || 0;

  return (
    <CustomerContacts
      endCustomerContacts={endCustomerContacts}
      totalCount={totalCount}
      isLoading={loading}
      error={error}
      addCustomerContactSidebarType={SIDEBAR.ADD_CUSTOMER_CONTACT}
      entitlementId={entitlementId}
      transactionAccountId={transactionAccountId as string}
      refetch={refetch}
    />
  );
};
